import { render } from "./ProductsForIntervention.vue?vue&type=template&id=1e613bee&scoped=true"
import script from "./ProductsForIntervention.vue?vue&type=script&lang=js"
export * from "./ProductsForIntervention.vue?vue&type=script&lang=js"

import "./ProductsForIntervention.vue?vue&type=style&index=0&id=1e613bee&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e613bee"]])

export default __exports__